import React from 'react'
import { Box, Typography, IconButton, Grid, Stack } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'

const SectionSummaryCard = ({ icon: Icon, title, items = [], onEdit }) => {
  const displayItems = items.filter(
    item => item.value !== '' && item.value !== false && item.value != null,
  )

  return (
    <Box
      sx={{
        p: 2,
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
      }}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={displayItems.length > 0 ? 1.5 : 0}>
        <Stack direction="row" alignItems="center" spacing={1}>
          {Icon && <Icon sx={{ fontSize: 20, color: 'primary.main' }} />}
          <Typography variant="subtitle2" fontWeight={600}>
            {title}
          </Typography>
        </Stack>
        {onEdit && (
          <IconButton size="small" onClick={onEdit} sx={{ color: 'primary.main' }}>
            <EditIcon sx={{ fontSize: 18 }} />
          </IconButton>
        )}
      </Stack>

      {displayItems.length > 0 ? (
        <Grid container spacing={0.5}>
          {displayItems.map((item, idx) => (
            <Grid item xs={6} key={idx}>
              <Typography variant="caption" color="text.secondary">
                {item.label}:{' '}
              </Typography>
              <Typography variant="caption" fontWeight={600}>
                {typeof item.value === 'boolean'
                  ? item.value
                    ? 'Sí'
                    : 'No'
                  : item.value}
              </Typography>
            </Grid>
          ))}
        </Grid>
      ) : (
        <Typography variant="caption" color="text.secondary" fontStyle="italic">
          Sin datos
        </Typography>
      )}
    </Box>
  )
}

export default SectionSummaryCard
